'use strict';

module.exports.equityOptionQuoteGrid = function () {
    const lastTradeDateTime = "data.pricedata.lasttradedatetime | momentjs 'true' 'MMM DD, YYYY'";

    return `
        <div rv-if="data.datatype | = 'equity option'">
            <div class="pure-g">
                <div class="pure-u-1-1 pure-u-sm-1-2">
                    <div class="qmod-box-wrap qmod-box-wrap-l">
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-last"
                            rv-if="data.pricedata.last"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.last| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    {data.pricedata.last | asQHLast tLang }
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-change"
                            rv-if="data.pricedata.change"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.net| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    {data.pricedata.change | numeraljs }
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-open"
                            rv-if="data.pricedata.open"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.open| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    {data.pricedata.open | numeraljs}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-high"
                            rv-if="data.pricedata.high"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.high| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    {data.pricedata.high | numeraljs}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-bid"
                            rv-if="data.pricedata.bid"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.bid| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">{data.pricedata.bid | numeraljs}</div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-bidsize"
                            rv-if="data.pricedata.bidsize"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.bidsize| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    {data.pricedata.bidsize | numeraljs '0'}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-contracthigh"
                            rv-if="data.contract.contracthigh"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.contracthigh| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    {data.contract.contracthigh | numeraljs}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-strike"
                            rv-if="data.contract.strike"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.strike| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    {data.contract.strike | numeraljs}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-openinterest"
                            rv-if="data.contract.openinterest"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.openinterest| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    {data.contract.openinterest | numeraljs '0,0'}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pure-u-1-1 pure-u-sm-1-2">
                    <div class="qmod-box-wrap qmod-box-wrap-r">
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-lasttradedatetime"
                            rv-if="data.pricedata.lasttradedatetime"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.date| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    <a class="qmod-tooltip"
                                        rv-title="${lastTradeDateTime}"
                                        rv-on-mouseenter="data.qmtooltip"
                                        rv-text="data.pricedata.lasttradedatetime | momentjs 'true' 'h:mmA'"
                                    ></a>
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-changepercent"
                            rv-if="data.pricedata.changepercent"
                        >
                            <div class="pure-u-1-2"><div class="qmod-label qmod-textl">Net&nbsp;%</div></div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    {data.pricedata.changepercent | numeraljs '0.00'}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-prevclose"
                            rv-if="data.pricedata.prevclose"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.prevclose| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    {data.pricedata.prevclose | numeraljs}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-low"
                            rv-if="data.pricedata.low"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.low| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    {data.pricedata.low | numeraljs}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-ask"
                            rv-if="data.pricedata.ask"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.ask| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">{data.pricedata.ask | numeraljs}</div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-asksize"
                            rv-if="data.pricedata.asksize"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.asksize| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    {data.pricedata.asksize | numeraljs '0'}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-contractlow"
                            rv-if="data.contract.contractlow"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.contractlow| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    {data.contract.contractlow | numeraljs}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-contractvolume"
                            rv-if="data.pricedata.contractvolume"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.volume| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    {data.pricedata.contractvolume | numeraljs '0,0'}
                                </div>
                            </div>
                        </div>
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-exShName"
                            rv-if="data.key.exShName"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.exchange| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    <a class="qmod-tooltip"
                                        rv-title="data.key.exLgName"
                                        rv-on-mouseenter="data.qmtooltip"
                                    >
                                        {data.key.exShName}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
};
